import { ActionTree } from 'vuex';
import serviceHub from '@/services/hub';

const youtubeActions: ActionTree<Store.LiveSocial.State, RootState> = {
  async youtubeGetUserData({ dispatch }, payload: Services.LiveSocial.Youtube.GetUserData) {
    return serviceHub.liveSocial.youtube.getUserData(payload)
      .then(({ data }) => data)
      .catch((error) => {
        console.error('Action - "liveSocial/youtubeGetUserData" ', error);

        dispatch(
          'notification/create', {
            text: 'error youtubeGetUserData()',
            type: 'error',
          }, { root: true },
        );

        return Promise.reject(error);
      });
  },
  async youtubeCreateLiveBroadcast(
    { dispatch },
    payload: Services.LiveSocial.Youtube.PostLiveBroadcast,
  ) {
    return serviceHub.liveSocial.youtube.postLiveBroadcast(payload)
      .then(({ data }) => {
        if ('error' in data) throw new Error((data as any).error.error.error.errors[0].reason);
        return data.data;
      })
      .catch((error: Error) => {
        if (error.message === 'userRequestsExceedRateLimit') {
          dispatch(
            'notification/create', {
              text: 'suspended_youtube_account',
              type: 'error',
            }, { root: true },
          );
          throw new Error('error_already_handled');
        }

        console.error('Action - "liveSocial/youtubeCreateLiveBroadcast" ', error);

        dispatch(
          'notification/create', {
            text: 'error youtubeCreateLiveBroadcast()',
            type: 'error',
          }, { root: true },
        );

        return Promise.reject(error);
      });
  },
  async youtubeCreateLiveStream(
    { dispatch },
    payload: Services.LiveSocial.Youtube.PostLiveStream,
  ) {
    return serviceHub.liveSocial.youtube.postLiveStream(payload)
      .then(({ data }) => {
        if ('error' in data) throw new Error((data as any).error.error.error.errors[0].reason);
        return data.data;
      })
      .catch((error: Error) => {
        if (error.message === 'userRequestsExceedRateLimit') {
          dispatch(
            'notification/create', {
              text: 'suspended_youtube_account',
              type: 'error',
            }, { root: true },
          );
          throw new Error('error_already_handled');
        }

        console.error('Action - "liveSocial/youtubeCreateLiveStream" ', error);

        dispatch(
          'notification/create', {
            text: 'error youtubeCreateLiveStream()',
            type: 'error',
          }, { root: true },
        );

        return Promise.reject(error);
      });
  },
  async youtubeBindBroadcastToStream(
    { dispatch },
    payload: Services.LiveSocial.Youtube.PostBindBroadcastToStream,
  ) {
    return serviceHub.liveSocial.youtube.postBindBroadcastToStream(payload)
      .then(({ data }) => {
        if ('error' in data) throw new Error((data as any).error.error.error.errors[0].reason);
        return data.data;
      })
      .catch((error: Error) => {
        if (error.message === 'userRequestsExceedRateLimit') {
          dispatch(
            'notification/create', {
              text: 'suspended_youtube_account',
              type: 'error',
            }, { root: true },
          );
          throw new Error('error_already_handled');
        }

        console.error('Action - "liveSocial/youtubeBindBroadcastToStream" ', error);

        dispatch(
          'notification/create', {
            text: 'error youtubeBindBroadcastToStream()',
            type: 'error',
          }, { root: true },
        );

        return Promise.reject(error);
      });
  },
  async youtubeCreateStreamTarget(
    { dispatch },
    payload: Services.LiveSocial.Youtube.CreateWowzaTarget,
  ) {
    return serviceHub.liveSocial.youtube.createWowzaTarget(payload)
      .then(({ data }) => data)
      .catch((error) => {
        console.error('Action - "liveSocial/youtubeCreateStreamTarget" ', error);

        dispatch(
          'notification/create', {
            text: 'error youtubeCreateStreamTarget()',
            type: 'error',
          }, { root: true },
        );

        return Promise.reject(error);
      });
  },
  async youtubeRemoveStreamTarget(
    { dispatch },
    payload: Services.LiveSocial.Youtube.RemoveWowzaTarget,
  ) {
    return serviceHub.liveSocial.youtube.removeWowzaTarget(payload)
      .then(({ data }) => data)
      .catch((error) => {
        console.error('Action - "liveSocial/youtubeRemoveStreamTarget" ', error);

        dispatch(
          'notification/create', {
            text: 'error youtubeRemoveStreamTarget()',
            type: 'error',
          }, { root: true },
        );

        return Promise.reject(error);
      });
  },
  async youtubeChangeStreamTarget(
    { dispatch },
    payload: Services.LiveSocial.Youtube.ChangeWowzaTarget,
  ) {
    return serviceHub.liveSocial.youtube.changeWowzaTarget(payload)
      .then(({ data }) => data)
      .catch((error) => {
        console.error('Action - "liveSocial/youtubeChangeStreamTarget" ', error);

        dispatch(
          'notification/create', {
            text: 'error youtubeChangeStreamTarget()',
            type: 'error',
          }, { root: true },
        );

        return Promise.reject(error);
      });
  },
};

export default youtubeActions;
